export const getAllTestimonials = state =>
  state.testimonials.testimonials.sort((a, b) => {
    if (a.name > b.name) return 1;
    if (a.name < b.name) return -1;
    return 0;
  });
export const addedToShowcase = state => state.testimonials.testimonials.filter(el => el.addedToShowcase);
export const isTestimonialsVisible = state => state.testimonials.testimonials.filter(el => el.addedToShowcase).length;
